// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.spinner {
  display: inline-block;
  border: 2px solid var(--border);
  border-top-color: currentColor;
  border-radius: 999px;
  animation: spinner-rotate 0.7s linear infinite;
  flex-shrink: 0;
}

@keyframes spinner-rotate {
  to {
    transform: rotate(360deg);
  }
}

/* Respect reduced-motion: keep a slow spin instead of a fast one. */
@media (prefers-reduced-motion: reduce) {
  .spinner {
    animation-duration: 1.6s;
  }
}
`, "",{"version":3,"sources":["webpack://./src/ui/Spinner/Spinner.css"],"names":[],"mappings":"AAAA;EACE,qBAAqB;EACrB,+BAA+B;EAC/B,8BAA8B;EAC9B,oBAAoB;EACpB,8CAA8C;EAC9C,cAAc;AAChB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA,oEAAoE;AACpE;EACE;IACE,wBAAwB;EAC1B;AACF","sourcesContent":[".spinner {\n  display: inline-block;\n  border: 2px solid var(--border);\n  border-top-color: currentColor;\n  border-radius: 999px;\n  animation: spinner-rotate 0.7s linear infinite;\n  flex-shrink: 0;\n}\n\n@keyframes spinner-rotate {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n/* Respect reduced-motion: keep a slow spin instead of a fast one. */\n@media (prefers-reduced-motion: reduce) {\n  .spinner {\n    animation-duration: 1.6s;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
